import React from 'react'
import styled from 'styled-components'
import {formatDate} from "../../../../utils/utils";

function Status200or400(props) {
  return (
    <React.Fragment>

        <div className='check-result__element'>
          <div className='check-result__title'>Проверка подлинности результата</div>
          {props.status === 200 ?
            <div className='check-result_green'>Результат обследования: Норма</div> :
            <div className='check-result_red'>{props.message}</div>
          }
        </div>
        <div className='patient__info'>
          <div style={{ borderTopLeftRadius: '20px', border: '1', borderTopRightRadius: '20px' }}
               className='patient__info__option white'>
            <div className='t'>ФИО</div>
            <div>{props?.patientInfo?.fio}</div>
          </div>
          <div className='patient__info__option gray'>
            <div className='t'>Дата рождения</div>
            <div>{formatDate(props?.patientInfo?.dob)}</div>
          </div>
          <div className='patient__info__option white'>
            <div className='t'>Номер мед книжки</div>
            <div>{props?.patientInfo?.med_book}</div>
          </div>
          <div style={{ borderBottomLeftRadius: '20px', border: '1', borderBottomRightRadius: '20px' }}
               className='patient__info__option gray'>
            <div style={{ border: '0px' }} className='t'>Дата прохождения</div>
            <div style={{ border: '0px' }}>{formatDate(props?.patientInfo?.resultDate)}</div>
          </div>
        </div>

    </React.Fragment>
  )
}


export default Status200or400
